export default class ViewportProviderInterface {
    constructor(options = {}) {
        this.options = options;
    }

    /**
     * Fetch viewports for a given bubble.
     *
     * @param {Autodesk.Viewing.BubbleNode} bubbleNode - bubbleNode.
     *
     * @returns {Promise<[Viewport]>} Promise with array of viewports.
     */
    async fetchViewports() {
        throw "fetchViewports not implemented";
    }

    /**
     * @returns {string} Name of viewport provider
     */
    static getProviderName() {
        throw "getProviderName not implemented";
    }

    /**
     *
     * @param {Viewport} vp - the viewport to delete
     *
     * @returns {boolean} True if the viewport was deleted
     */
    async deleteViewport() {
        throw "deleteViewport not implemented";
    }
}
